var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import { useApolloClient, ApolloClient, InMemoryCache } from "@apollo/client";
import { useState, useEffect, useMemo } from "react";
var STATIC_APOLLO_CLIENT = new ApolloClient({
  cache: new InMemoryCache(),
  uri: "",
  // Empty or placeholder, prevents network requests
  ssrMode: true // Prevents client-side execution during SSR
});
export function useSafeApolloClient() {
  var _a = __read(useState(false), 2),
    isHydrated = _a[0],
    setIsHydrated = _a[1];
  useEffect(function () {
    setIsHydrated(true);
  }, []);
  var realClient = useApolloClient();
  return useMemo(function () {
    return isHydrated ? realClient : STATIC_APOLLO_CLIENT;
  }, [isHydrated, realClient]);
}